import PageImage from './PageImage';

interface Props {
  src: string;
  bgClassName?: string;
  blackMaskOpacity?: string;
}

export default function AnchorCardBg({
  src,
  bgClassName,
  blackMaskOpacity = '0%',
}: Props) {
  return (
    <>
      <PageImage
        src={src}
        alt=""
        className={cn(
          'absolute w-full -top-50 left-1/2 -translate-x-1/2',
          bgClassName
        )}
      />
      <div
        className="absolute w-full h-full bg-black inset-0"
        style={{
          opacity: blackMaskOpacity,
        }}
      />
    </>
  );
}
